export const DTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const formatWithTZ = (date, options = {}) => {
  if (!date) return "—";

  // 👇 force JS to treat backend time as UTC
  const utcDate = new Date(date + "Z");

  return new Intl.DateTimeFormat("en-IN", {
    timeZone: DTZ,
    dateStyle: "medium",
    timeStyle: "short",
    ...options,
  }).format(utcDate);
};
